import { LinkButton } from '@/atoms/Button'
import { Image } from '@/atoms/Image'
import { HeadingMD, ParagraphSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'
import { TORCH_APPLICATION_FEE } from '../utils/payment'

export const HeroSection = () => {
  const { t } = useTranslate('guild-create')
  const title = t('submitYourFilmOrConceptToAngel', 'Submit Your Film or Concept to Angel')

  return (
    <div className="flex flex-col items-center gap-4 px-6">
      <Image
        src="v1703019304/angel-app/guild/hero-poster-web_2x.webp"
        alt="Guild Submission Projects Banner"
        width={1000}
        height={400}
        className="w-full max-w-4xl object-cover"
      />
      <div>
        <HeadingMD className="text-center lg:max-w-2xl lg:text-5xl" weight="bold">
          {title}
        </HeadingMD>
        <ParagraphSM className="pt-3 text-center">
          {t('aXSubmissionFeeWillApply', 'A {{ amount }} submission fee will apply', {
            amount: TORCH_APPLICATION_FEE,
          })}
        </ParagraphSM>
      </div>
      <LinkButton variant="oxide" href={paths.guild.create.torch}>
        Submit Now
      </LinkButton>
    </div>
  )
}
